import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/catalog?q=${encodeURIComponent(query)}`);
  };

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8f7e9545426451dd2c6dc83ba3ffafbc.jpg"
          alt="Junk journal and snail mail crafting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-24 pb-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white text-xs font-medium tracking-widest uppercase mb-8">
          <i className="ri-sparkling-line text-[#f0c87a]"></i>
          The Creative Community Directory
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Discover Your<br />
          <span className="text-[#f0c87a]">Creative Community</span>
        </h1>

        <p className="text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          The definitive directory of junk journal and snail mail creators. Find handmade papers, washi tapes, stamps, ephemera, and everything in between.
        </p>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto mb-10">
          <div className="flex-1 relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#8b7355]">
              <i className="ri-search-line"></i>
            </div>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search creators, products, categories..."
              className="w-full pl-11 pr-4 py-3.5 rounded-full bg-white/95 text-[#3a2e1e] placeholder-[#9a8a78] text-sm focus:outline-none focus:ring-2 focus:ring-[#f0c87a]"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-3.5 rounded-full bg-[#8b5e3c] text-white font-semibold text-sm hover:bg-[#7a5234] transition-colors whitespace-nowrap"
          >
            Search Directory
          </button>
        </form>

        {/* Quick Filter Tags */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {["Ephemera", "Washi Tape", "Stamps", "Snail Mail Kits", "Stickers", "Journal Kits"].map((tag) => (
            <button
              key={tag}
              onClick={() => navigate(`/catalog?q=${encodeURIComponent(tag)}`)}
              className="px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white text-xs hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs tracking-widest uppercase">Scroll to explore</span>
        <div className="w-5 h-5 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-line"></i>
        </div>
      </div>
    </section>
  );
}
